import { render, staticRenderFns } from "./memberUploadAttachments.vue?vue&type=template&id=0fe1f7cd&scoped=true&"
import script from "./memberUploadAttachments.vue?vue&type=script&lang=js&"
export * from "./memberUploadAttachments.vue?vue&type=script&lang=js&"
import style0 from "./memberUploadAttachments.vue?vue&type=style&index=0&id=0fe1f7cd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe1f7cd",
  null
  
)

export default component.exports